export { default as PesajeTraslado } from "./PesajeTraslado";
